import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { IBrandDto } from 'src/app/services/api.service';

@Component({
  selector: 'app-brand-recall-dialog',
  templateUrl: './brand-recall-dialog.component.html',
  styleUrl: './brand-recall-dialog.component.css',
  standalone: false,
})
export class BrandRecallDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) data: { brand: IBrandDto }) {
    this.res.recallSelectionRange = data.brand.recallSelectionRange;
    this.res.isRecallLastVisitDate = data.brand.isRecallLastVisit;
    this.res.brandId = data.brand.brandId;
  }

  public res: BrandRecallDialogResult = new BrandRecallDialogResult();
}

export class BrandRecallDialogResult {
  public brandId: number = 0;
  public recallSelectionRange: number = 30;
  public isRecallLastVisitDate: boolean = false;
}
